import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectActions } from "UserAuthorized/selectors/enumSelector";
import { selectMagicLink } from "UserAuthorized/selectors/actionSelector";
import { enumGetActions } from "UserAuthorized/actions/enum";
import {
  actionSaveAction,
  actionClearMagicLink
} from "UserAuthorized/actions/action";
import EYMagicLinkGenerator from "UserAuthorized/components/EYMagicLinkGenerator";
import Toaster from "components/Toaster";

const mapStateToProps = state => {
  return {
    actions: selectActions(state),
    magicLink: selectMagicLink(state)
  };
};
const mapDispatchToProps = dispatch => {
  return {
    enumGetActions: () => dispatch(enumGetActions()),
    actionSaveAction: actionRequest =>
      dispatch(actionSaveAction(actionRequest)),
    actionClearMagicLink: () => dispatch(actionClearMagicLink())
  };
};
class MagicLinkGeneratorContainer extends React.Component {
  static propTypes = {
    actions: PropTypes.array,
    magicLink: PropTypes.object,
    enumGetActions: PropTypes.func,
    actionSaveAction: PropTypes.func,
    actionClearMagicLink: PropTypes.func
  };
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.init();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.magicLink != this.props.magicLink &&
      nextProps.magicLink.success === true
    ) {
      Toaster.success("Magic Link generated successfully");
      this.props.actionClearMagicLink();
    }
  }
  init = () => {
    this.props.enumGetActions();
  };
  render() {
    const { actions, actionSaveAction, magicLink } = this.props;
    return (
      <React.Fragment>
        <EYMagicLinkGenerator
          actions={actions}
          actionSaveAction={actionSaveAction}
          magicLink={magicLink}
        />
      </React.Fragment>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MagicLinkGeneratorContainer);
